module.exports = __webpack_public_path__ + "img/bg_gongcan.dd5c09b6.png";